import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  subtitle: {
    padding: '0px 10px',
  },
}));

export default useStyles;
